import React from "react";
import { withRouter } from "react-router";

const Header = ({ location }) => (
  <div></div>
);

export default withRouter(Header);
